import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import papi, { formatErr } from "@/lib/partnerApi";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";

const LOGO = "https://customer-assets-jai6qajn.emergentagent.net/job_buildguard-preview/artifacts/3lbt7aob_nirmantra_ai_icon.png";

export default function StaffLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const role = localStorage.getItem("partner_role");
    if (role === "admin") navigate("/admin"); else if (role === "manager") navigate("/manager");
  }, [navigate]);

  const submit = async () => {
    setLoading(true);
    try {
      const { data } = await papi.post("/partner/auth/login", { email, password });
      localStorage.setItem("partner_token", data.token);
      localStorage.setItem("partner_role", data.user.role);
      toast.success(`Welcome, ${data.user.name}`);
      navigate(data.user.role === "admin" ? "/admin" : "/manager");
    } catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#FBFAF9] flex flex-col items-center justify-center px-6">
      <Link to="/" className="flex items-center gap-2.5 mb-8"><img src={LOGO} className="h-10 w-10 rounded-xl" alt="" /><span className="font-display font-extrabold text-xl">Nirmantra<span className="text-[#0E9AC8]">.ai</span> <span className="text-slate-400 text-base font-medium">Staff</span></span></Link>
      <div className="card-premium rounded-2xl p-8 w-full max-w-md">
        <div className="h-12 w-12 rounded-xl bg-[#0E9AC8]/10 flex items-center justify-center mb-5"><Lock className="h-6 w-6 text-[#0E9AC8]" /></div>
        <h1 className="font-display text-2xl font-extrabold text-slate-900">Staff Sign in</h1>
        <p className="text-sm text-slate-500 mt-1">For Vendor Managers & Super Admins.</p>
        <div className="mt-6 space-y-4">
          <div><Label>Email</Label><Input data-testid="staff-email" className="rounded-xl mt-1.5" value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} /></div>
          <div><Label>Password</Label><Input data-testid="staff-password" type="password" className="rounded-xl mt-1.5" value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} /></div>
          <Button data-testid="staff-login" onClick={submit} disabled={loading} className="w-full bg-[#0E9AC8] hover:bg-[#0B7EA4] text-white rounded-xl h-11">{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}</Button>
        </div>
      </div>
      <p className="mt-6 text-sm text-slate-500">Are you a vendor? <Link to="/vendor/register" className="text-[#0E9AC8] font-semibold">Register here</Link></p>
    </div>
  );
}
